import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import SportsSoccer from '@mui/icons-material/SportsSoccer';
import IconButton from '@mui/material/IconButton';
import { useNavigate, useMatch } from 'react-router';
import Button from '@mui/material/Button';
import ReplayIcon from '@mui/icons-material/Replay';

import { draw, base64ToObject, objectToBase64, drawFormations } from '../utils';
import { Player, Team, TeamResult, ViewMode } from '../types';
import { Copyright } from './Copyright';

type AppProps = {
  readonly children: React.ReactNode;
};

export default function App({ children }: AppProps) {
  const navigate = useNavigate();
  const match = useMatch('/results/:resultCode');

  const handleClick = () => {
    navigate('/');
  };

  const handleRedraw = () => {
    try {
      if (!match) {
        throw new Error('Wrong path');
      }
      const result = base64ToObject(
        (match?.params as any).resultCode
      ) as TeamResult;
      const numTeam = result.teams.length;
      const players = result.teams.reduce(
        (acc: Player[], team: Team) => [...acc, ...team.players],
        []
      );
      const newResult = draw(players, numTeam, result.date);
      // Reset player positions
      newResult.teams.forEach((team) => {
        team.players.forEach((player) => {
          player.position = undefined;
        });
      });
      if (result.viewMode === ViewMode.Formation) {
        newResult.viewMode = result.viewMode;
        drawFormations(newResult);
      }
      const newCode = objectToBase64(newResult);
      navigate(`/results/${newCode}`);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar variant="dense">
          <IconButton
            edge="start"
            color="inherit"
            sx={{ mr: 1 }}
            onClick={handleClick}
          >
            <SportsSoccer />
          </IconButton>
          <Typography variant="h6" color="inherit" component="div">
            HuhiFC
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          {match && (
            <Button
              variant="outlined"
              color="inherit"
              startIcon={<ReplayIcon />}
              onClick={handleRedraw}
            >
              Redraw
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Box
        component="main"
        sx={{
          minHeight: 'calc(100vh - 112px)',
          padding: {
            xs: 1,
            sm: 1,
            mb: 2,
            lg: 2,
          },
          justifyContent: 'center',
        }}
      >
        {children}
        <Copyright />
      </Box>
    </Box>
  );
}
